import { Grid } from '@material-ui/core';

import { AssessmentResult } from '@/components/modules/Risk/RiskScore/components/AssessmentResult';
import { useRiskScore } from '@/components/modules/Risk/RiskScore/hooks/useRiskScore';
import { RiskAssessmentType } from '@/components/modules/Risk/RiskScore/types/RiskAssessmentType';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { OnboardingDetails, PendingDataType } from '@/config/types';

interface RiskResultsProps {
  loanId: string;
  onboardingDetails?: OnboardingDetails;
}

export const RiskResults = ({ loanId, onboardingDetails }: RiskResultsProps) => {
  const originationRiskValues = useRiskScore({ loanId, onboardingDetails })?.originationRiskValues;

  return (
    <SubSectionWrapper title="RESULTS">
      {!originationRiskValues ? (
        <PendingDataWarning type={PendingDataType.NO_RISK_INFORMATION} />
      ) : (
        <Grid container spacing={4}>
          <Grid item xs={12} lg={6}>
            <ReadOnlyDataRow
              underlined
              forceSingleLine
              labelTextId={RiskAssessmentType.AML_RISK}
              value={<AssessmentResult result={originationRiskValues.amlRisk} type={RiskAssessmentType.AML_RISK} />}
            />
          </Grid>
          <Grid item xs={12} lg={6}>
            <ReadOnlyDataRow
              underlined
              forceSingleLine
              labelTextId={RiskAssessmentType.BANK_READER_RISK}
              value={
                <AssessmentResult
                  result={originationRiskValues.bankReaderRisk}
                  type={RiskAssessmentType.BANK_READER_RISK}
                />
              }
            />
          </Grid>
        </Grid>
      )}
    </SubSectionWrapper>
  );
};
